import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
/** Widths of the repeating tiles, in px; the strips scroll by exactly one tile. */ export const ROAD_TILE = 360;
export const HILL_TILE = 720;
/**
 * A country road side on, for the kei van to drive along: far hills, a roadside of pines,
 * km posts, a telephone pole and grass, and the road with its dashed centre line. Each layer
 * is a pattern on a strip one tile wider than the scene, so sliding a strip left by one tile
 * and starting over loops seamlessly. Decorative. `className`s on the strips (`mk-road__hills`,
 * `mk-road__side`) are what the carousel animates.
 */ export function RoadScene() {
    const id = useId().replace(/:/g, '');
    const hills = `${id}h`;
    const side = `${id}s`;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mk-road__scene",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsxs("svg", {
                className: "mk-ill mk-road__hills",
                height: "96",
                children: [
                    /*#__PURE__*/ _jsx("defs", {
                        children: /*#__PURE__*/ _jsx("pattern", {
                            id: hills,
                            width: HILL_TILE,
                            height: "96",
                            patternUnits: "userSpaceOnUse",
                            children: /*#__PURE__*/ _jsx("path", {
                                className: "fh n",
                                d: "M0 96V72C40 64 70 54 110 54c34 0 52 10 84 10 40 0 64-14 112-14 46 0 66 16 104 16 30 0 52-8 86-8 40 0 62 12 98 12 40 0 86 10 126 2v24Z",
                                opacity: ".55"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "n",
                        width: "100%",
                        height: "96",
                        fill: `url(#${hills})`
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("svg", {
                className: "mk-ill mk-road__side",
                height: "96",
                children: [
                    /*#__PURE__*/ _jsx("defs", {
                        children: /*#__PURE__*/ _jsxs("pattern", {
                            id: side,
                            width: ROAD_TILE,
                            height: "96",
                            patternUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fh n",
                                    d: "M0 56h360v6H0Z",
                                    opacity: ".8"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M0 56h360"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fa2",
                                    d: "m40 56 12-24 12 24Zm-5-10 17-18 17 18Z",
                                    opacity: ".9"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M52 56v-4"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fp thin",
                                    d: "M122 56V40c0-1.6 1-2.6 2.6-2.6h4.8c1.6 0 2.6 1 2.6 2.6v16Z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fb n",
                                    d: "M122.6 41h8.8v3.4h-8.8Z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "sa",
                                    d: "M232 56V6M222 10h20M224 15h16"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "sa thin",
                                    d: "M232 10q64 4.3 128 5.5M0 15.5q116 2.2 232-5.5M232 15q64 4.3 128 5.5M0 20.5q116 2.2 232-5.5",
                                    opacity: ".5"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "sa thin",
                                    d: "M180 56c1-5 3-7 4-8m2 8c0-4-1-6-2-8m7 8c1-4 3-6 5-7M300 56c1-4 3-6 4-7m3 7c0-3-1-5-2-7"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fa2",
                                    d: "m316 56 8-18 8 18Z",
                                    opacity: ".75"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fs n",
                                    d: "M0 62h360v34H0Z"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "sa thin",
                                    d: "M0 63h360",
                                    opacity: ".6"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "fp n",
                                    d: "M10 78h34v3H10Zm90 0h34v3h-34Zm90 0h34v3h-34Zm90 0h34v3h-34Z"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "n",
                        width: "100%",
                        height: "96",
                        fill: `url(#${side})`
                    })
                ]
            })
        ]
    });
}
